import React from 'react'
import { CardContent } from '@material-ui/core'
import { useStyles } from './signUpContent.css'
import clsx from 'clsx'

interface Props {
    className?: string
}

const SignUpContent: React.FC<Props> = ({ children, className }) => {
    const classes = useStyles()
    return <CardContent className={clsx(classes.cardContent, className)}>{children}</CardContent>
}

export default SignUpContent
